<ng-container *ngIf="!showOnlyPublic">
  <ng-container *ngIf="(isAuthenticated$ | async).isAuthenticated">
    <div class="flex flex-col">
      <app-header class="z-0 shadow-md" *ngIf="!isHiddenHeader" />
      <div class="h-full overflow-y-auto">
        <router-outlet />
      </div>
      <ng-container *ngIf="(appInitialized$ | async)?.initialized">
        <app-message-data />

        <p-toast />

        <!-- Modale visualizzazione log -->
        <app-entity-log />

        <!-- Modale aggiunta nota -->
        <app-gen-nota-add />

        <!-- Modale export griglia -->
        <app-list-export />
      </ng-container>
    </div>
  </ng-container>
</ng-container>
<ng-container *ngIf="showOnlyPublic">
  <router-outlet />
</ng-container>
